import { render, staticRenderFns } from "./TargetsPage.vue?vue&type=template&id=b153656e"
import script from "./TargetsPage.vue?vue&type=script&lang=js"
export * from "./TargetsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports